import {
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
  NullBody_instanceoz9dr731l81q as NullBody_instance,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import {
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  getKClass3t8tygqu4lcxf as getKClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { contentType2zzm38yxo3syt as contentType } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import {
  toString30pk9tzaqopn as toString_0,
  arrayOf1akklvh2at202 as arrayOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { trimMarginhyd3fsmh8iev as trimMargin } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { get_MaxRetriesPerRequestAttributeKey13gphm9kuo852 as get_MaxRetriesPerRequestAttributeKey } from './HttpRequestRetry.mjs';
import { reversed22y3au42jl32b as reversed } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { cancel36mj9lv3a0whl as cancel } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from '../call/HttpClientCall.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { Phases_getInstance153dg9ipormlv as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$intercept, content, $completion) {
  // Inline function 'kotlin.check' call
  if (!(content instanceof OutgoingContent())) {
    var message = trimMargin('\n|Fail to prepare request body for sending. \n|The body type is: ' + toString(getKClassFromExpression(content)) + ', with Content-Type: ' + toString_0(contentType($this$intercept.m4r_1)) + '.\n|\n|If you expect serialized body, please check that you have installed the corresponding plugin(like `ContentNegotiation`) and set `Content-Type` header.');
    throw IllegalStateException().o(toString(message));
  }
  // Inline function 'io.ktor.client.request.setBody' call
  var this_0 = $this$intercept.m4r_1;
  if (content == null) {
    this_0.u5g_1 = NullBody_instance;
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(OutgoingContent());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(OutgoingContent()), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$3 = new (TypeInfo())(tmp, tmp$ret$2);
    this_0.f5l(tmp$ret$3);
  } else {
    if (content instanceof OutgoingContent()) {
      this_0.u5g_1 = content;
      this_0.f5l(null);
    } else {
      this_0.u5g_1 = content;
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_2 = getKClass(OutgoingContent());
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_3;
      try {
        tmp_3 = createKType(getKClass(OutgoingContent()), arrayOf([]), false);
      } catch ($p) {
        var tmp_4;
        if ($p instanceof Error) {
          var _unused_var__etf5q3_0 = $p;
          tmp_4 = null;
        } else {
          throw $p;
        }
        tmp_3 = tmp_4;
      }
      var tmp$ret$4 = tmp_3;
      var tmp$ret$5 = new (TypeInfo())(tmp_2, tmp$ret$4);
      this_0.f5l(tmp$ret$5);
    }
  }
  var maxRetriesFromRetryPlugin = $this$intercept.m4r_1.w5g_1.v4m(get_MaxRetriesPerRequestAttributeKey());
  var tmp_5;
  if (!(maxRetriesFromRetryPlugin == null)) {
    var tmp_6;
    if (maxRetriesFromRetryPlugin < 2147483647) {
      tmp_6 = maxRetriesFromRetryPlugin + 1 | 0;
    } else {
      tmp_6 = maxRetriesFromRetryPlugin;
    }
    tmp_5 = tmp_6;
  } else {
    tmp_5 = $this.s5s_1.q5s_1;
  }
  var maxRetries = tmp_5;
  var realSender = new (DefaultSender())(maxRetries, $this.t5s_1);
  var interceptedSender = realSender;
  var _iterator__ex2g4s = reversed($this.s5s_1.r5s_1).u1();
  while (_iterator__ex2g4s.v1()) {
    var interceptor = _iterator__ex2g4s.w1();
    interceptedSender = new (InterceptedSender())(interceptor, interceptedSender);
  }
  var tmp_7 = interceptedSender.u5s($this$intercept.m4r_1, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  var call = tmp_7;
  var tmp_8 = $this$intercept.o4q(call, $completion);
  if (tmp_8 === get_COROUTINE_SUSPENDED())
    tmp_8 = yield tmp_8;
  return Unit_instance;
}
var HttpSend$Plugin$install$slambdaClass;
function HttpSend$Plugin$install$slambda() {
  if (HttpSend$Plugin$install$slambdaClass === VOID) {
    class $ {
      constructor($plugin, $scope) {
        this.s5s_1 = $plugin;
        this.t5s_1 = $scope;
      }
      x5g($this$intercept, content, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$intercept, content), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.x5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpSend$Plugin$install$slambdaClass = $;
  }
  return HttpSend$Plugin$install$slambdaClass;
}
function HttpSend$Plugin$install$slambda_0($plugin, $scope) {
  var i = new (HttpSend$Plugin$install$slambda())($plugin, $scope);
  var l = ($this$intercept, content, $completion) => i.x5g($this$intercept, content, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_execute__d6syw1($this, requestBuilder, $completion) {
  var tmp0_safe_receiver = $this.y5s_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    cancel(tmp0_safe_receiver);
  }
  if ($this.x5s_1 >= $this.v5s_1) {
    throw SendCountExceedException().d5t('Max send count ' + $this.v5s_1 + ' exceeded. Consider increasing the property ' + 'maxSendCount if more is required.');
  }
  $this.x5s_1 = $this.x5s_1 + 1 | 0;
  var tmp = $this.w5s_1.c5g_1.l4r(requestBuilder, requestBuilder.u5g_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var sendResult = tmp;
  var tmp1_elvis_lhs = sendResult instanceof HttpClientCall() ? sendResult : null;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var message = 'Failed to execute send pipeline. Expected [HttpClientCall], but received ' + toString(sendResult);
    throw IllegalStateException().o(toString(message));
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var call = tmp_0;
  $this.y5s_1 = call;
  return call;
}
var ConfigClass;
function Config() {
  if (ConfigClass === VOID) {
    class $ {
      constructor() {
        this.e5t_1 = 20;
      }
    }
    initMetadataForClass($, 'Config', Config);
    ConfigClass = $;
  }
  return ConfigClass;
}
var PluginClass;
function Plugin() {
  if (PluginClass === VOID) {
    class $ {
      constructor() {
        Plugin_instance = this;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'HttpSend';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = getKClass(HttpSend());
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_1;
        try {
          tmp_1 = createKType(getKClass(HttpSend()), arrayOf([]), false);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_1 = tmp_2;
        }
        var tmp$ret$0 = tmp_1;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$0);
        tmp.f5t_1 = new (AttributeKey())(name, tmp$ret$1);
      }
      r3() {
        return this.f5t_1;
      }
      g5t(block) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (Config())();
        block(this_0);
        var config = this_0;
        return new (HttpSend())(config.e5t_1);
      }
      a5i(block) {
        return this.g5t(block);
      }
      h5t(plugin, scope) {
        var tmp = Phases_getInstance().p5m_1;
        scope.a5g_1.q4r(tmp, HttpSend$Plugin$install$slambda_0(plugin, scope));
      }
      b5i(plugin, scope) {
        return this.h5t(plugin instanceof HttpSend() ? plugin : THROW_CCE(), scope);
      }
    }
    initMetadataForObject($, 'Plugin');
    PluginClass = $;
  }
  return PluginClass;
}
var Plugin_instance;
function Plugin_getInstance() {
  if (Plugin_instance === VOID)
    new (Plugin())();
  return Plugin_instance;
}
var InterceptedSenderClass;
function InterceptedSender() {
  if (InterceptedSenderClass === VOID) {
    class $ {
      constructor(interceptor, nextSender) {
        this.i5t_1 = interceptor;
        this.j5t_1 = nextSender;
      }
      u5s(requestBuilder, $completion) {
        return this.i5t_1(this.j5t_1, requestBuilder, $completion);
      }
    }
    initMetadataForClass($, 'InterceptedSender', VOID, VOID, [Sender()], [1]);
    InterceptedSenderClass = $;
  }
  return InterceptedSenderClass;
}
var DefaultSenderClass;
function DefaultSender() {
  if (DefaultSenderClass === VOID) {
    class $ {
      constructor(maxSendCount, client) {
        this.v5s_1 = maxSendCount;
        this.w5s_1 = client;
        this.x5s_1 = 0;
        this.y5s_1 = null;
      }
      u5s(requestBuilder, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_execute__d6syw1.bind(VOID, this, requestBuilder), $completion);
      }
    }
    initMetadataForClass($, 'DefaultSender', VOID, VOID, [Sender()], [1]);
    DefaultSenderClass = $;
  }
  return DefaultSenderClass;
}
var HttpSendClass;
function HttpSend() {
  if (HttpSendClass === VOID) {
    class $ {
      constructor(maxSendCount) {
        Plugin_getInstance();
        maxSendCount = maxSendCount === VOID ? 20 : maxSendCount;
        this.q5s_1 = maxSendCount;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.r5s_1 = ArrayList().u2();
      }
      k5t(block) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.r5s_1.n2(block);
      }
    }
    initMetadataForClass($, 'HttpSend');
    HttpSendClass = $;
  }
  return HttpSendClass;
}
var SenderClass;
function Sender() {
  if (SenderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Sender', VOID, VOID, VOID, [1]);
    SenderClass = $;
  }
  return SenderClass;
}
var SendCountExceedExceptionClass;
function SendCountExceedException() {
  if (SendCountExceedExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static d5t(message) {
        var $this = this.o(message);
        captureStack($this, $this.c5t_1);
        return $this;
      }
    }
    initMetadataForClass($, 'SendCountExceedException');
    SendCountExceedExceptionClass = $;
  }
  return SendCountExceedExceptionClass;
}
//region block: exports
export {
  Plugin_getInstance as Plugin_getInstance326p2fy5fh97r,
  Sender as Sender4pyqqer9k7up,
};
//endregion

//# sourceMappingURL=HttpSend.mjs.map
